import React from 'react';

const Copy = () => (
  <svg
    width="22px"
    height="26px"
    viewBox="0 0 22 26"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Group-8" fill="#FFFFFF" fillRule="nonzero" stroke="#336081" strokeWidth="1.5">
        <rect id="Rectangle-7-Copy" x="0.75" y="0.75" width="16.5" height="20.5" rx="1" />
        <rect id="Rectangle-7" x="4.75" y="4.75" width="16.5" height="20.5" rx="1" />
      </g>
    </g>
  </svg>
);

export default Copy;



// WEBPACK FOOTER //
// ./src/cards/components/common/ui/icons/CopyIcon.jsx